import { useEffect, useRef } from "react";

export default function useFocusOnChange(value) {
  const ref = useRef(null);
  const previous = useRef(value);

  useEffect(() => {
    if (previous.current === value) return;
    previous.current = value;
    if (ref.current) ref.current.focus();
  }, [value]);

  return ref;
}
